import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLinkPaymentLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 40 40",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 20,
		cy: 20,
		r: 20,
		fill: "#00d66f"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M19.08 8h-6.168c1.2 5.017 4.704 9.305 9.088 12-4.392 2.697-7.888 6.985-9.088 12h6.168c1.528-4.64 5.76-8.672 10.96-9.495v-5.017C24.832 16.672 20.6 12.64 19.08 8Z",
		fill: "#011e0f"
	})]
});
export default SvgLinkPaymentLogo;
